import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import { adsHelper } from '@dmm/react-common-components';
import { getLegacyMappingFromBoatClass } from '../../../../utils/classHelper';
import {
  canonicalizeDataString,
  isValidCondition
} from '../../../../utils/ads/adsUtils';
import * as utils from '../../../../store/utils';

export const adsConfig = {
  'div-gpt-ad-leaderboard-bdp-top': {
    breakpoint: {
      min: 970,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[728, 90]],
    targeting: {
      pos: 'leaderboard-top'
    }
  },
  'div-gpt-ad-leaderboard-top': {
    breakpoint: {
      min: 1120,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[728, 90]],
    targeting: {
      pos: 'leaderboard-top'
    }
  },
  'div-gpt-modal-ad-leaderboard-top': {
    breakpoint: {
      min: 768,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[728, 90]],
    targeting: {
      pos: 'leaderboard-top'
    },
    isLazy: true
  },
  'div-gpt-ad-box-1': {
    breakpoint: {
      min: 970,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [
      [300, 250],
      [300, 600]
    ],
    targeting: {
      pos: 'box-1'
    }
  },
  'div-gpt-ad-box-2': {
    breakpoint: {
      min: 970,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[300, 250]],
    targeting: {
      pos: 'box-2'
    }
  },
  'div-gpt-ad-box-3': {
    breakpoint: {
      min: 970,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[300, 250]],
    targeting: {
      pos: 'box-3'
    },
    isLazy: true
  },
  'div-gpt-ad-mobile-leaderboard-1': {
    breakpoint: {
      min: 0,
      max: 1119
    },
    size: [[320, 50]],
    targeting: {
      pos: 'mobile-leaderboard-1'
    }
  },
  'div-gpt-ad-mobile-bdp-leaderboard-1': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [[320, 50]],
    targeting: {
      pos: 'mobile-leaderboard-1'
    }
  },
  'div-gpt-ad-mobile-box-1': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [[300, 250]],
    targeting: {
      pos: 'mobile-box-1'
    }
  },
  'div-gpt-ad-mobile-box-2': {
    breakpoint: {
      min: 0,
      max: 1119
    },
    size: [[300, 250]],
    targeting: {
      pos: 'mobile-box-2'
    }
  },
  'div-gpt-ad-leaderboard-bottom': {
    breakpoint: {
      min: 1120,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [[728, 90]],
    targeting: {
      pos: 'leaderboard-bottom'
    },
    isLazy: true
  },
  'div-gpt-ad-shipping': {
    breakpoint: {
      min: 0,
      max: Number.MAX_SAFE_INTEGER
    },
    size: ['fluid', [427, 68]],
    targeting: {
      pos: 'shipping'
    },
    isLazy: true
  },
  'div-gpt-ad-insurance': {
    breakpoint: {
      min: 0,
      max: Number.MAX_SAFE_INTEGER
    },
    size: ['fluid', [427, 68]],
    targeting: {
      pos: 'insurance'
    },
    isLazy: true
  },
  'div-gpt-ad-finance': {
    breakpoint: {
      min: 0,
      max: Number.MAX_SAFE_INTEGER
    },
    size: ['fluid', [427, 68]],
    targeting: {
      pos: 'finance'
    },
    isLazy: true
  },
  'div-gpt-ad-warranty': {
    breakpoint: {
      min: 0,
      max: Number.MAX_SAFE_INTEGER
    },
    size: ['fluid', [427, 68]],
    targeting: {
      pos: 'warranty'
    },
    isLazy: true
  },
  'div-gpt-ad-image-carousel-box1': {
    breakpoint: {
      min: 1440,
      max: Number.MAX_SAFE_INTEGER
    },
    size: [
      [300, 250],
      [300, 600]
    ],
    targeting: {
      pos: 'box-1'
    },
    isLazy: true
  },
  'div-gpt-ad-mobile-carousel-leaderboard-1': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [
      [320, 50],
      [320, 100]
    ],
    targeting: {
      pos: 'mobile-leaderboard-1'
    }
  },
  'div-gpt-ad-mobile-carousel-leaderboard-2': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [
      [320, 50],
      [320, 100]
    ],
    targeting: {
      pos: 'mobile-leaderboard-2'
    }
  },
  'div-gpt-ad-mobile-carousel-leaderboard-3': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [
      [320, 50],
      [320, 100]
    ],
    targeting: {
      pos: 'mobile-leaderboard-3'
    }
  },
  'div-gpt-ad-mobile-carousel-leaderboard-4': {
    breakpoint: {
      min: 0,
      max: 969
    },
    size: [
      [320, 50],
      [320, 100]
    ],
    targeting: {
      pos: 'mobile-leaderboard-4'
    }
  }
};

export const getTargeting = (listing, uom) => {
  let length = get(listing, `specifications.dimensions.lengths.nominal.${uom}`);
  let state = get(listing, 'location.address.subdivision');
  let zip = get(listing, 'location.address.postalCode');
  let boatCity = get(listing, 'location.address.city');
  let boatCountry = get(listing, 'location.address.country');
  let ownerId = get(listing, 'owner.id');
  let dealerCity = get(listing, 'owner.location.address.city');
  let dealerCountry = get(listing, 'owner.location.address.country');
  let ksg = utils.isServer() ? undefined : get(window, 'Krux.segments');
  let kuid = utils.isServer() ? undefined : get(window, 'Krux.user');
  let targeting = {
    type: canonicalizeDataString(listing.type),
    class: canonicalizeDataString(getLegacyMappingFromBoatClass(listing.class)),
    condition: isValidCondition(listing.condition)
      ? listing.condition
      : undefined,
    length: adsHelper.getLengthRanges(length, length, uom),
    year: adsHelper.getYearRanges(listing.year, listing.year),
    make: listing.make ? canonicalizeDataString(listing.make) : undefined,
    // eslint-disable-next-line camelcase
    dealer_id: ownerId ? ownerId + '' : undefined,
    dealercountry: dealerCountry,
    dealercity: dealerCity,
    boatcountry: boatCountry,
    boatcity: boatCity,
    state: state || undefined,
    // eslint-disable-next-line camelcase
    zip_code: zip ? zip : undefined,
    page: 'boat-details',
    ksg,
    kuid,
    modelyear: listing.year ? listing.year + '' : undefined
  };

  targeting = omitBy(targeting, isUndefined);

  return targeting;
};
